import "./App.css";
// import Navbar from "./Container/Navbar/Navbar";
import Footer from "./Container/Footer/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./Pages/Homepage";
import ThankyouPage from "./Pages/ThankyouPage";

function App() {
  return (
    <div className="App">
      <Router>
        {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<Homepage/>}/>
          <Route path="/thankyou" element={<ThankyouPage/>}/>
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
